import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

const sendRTBatiment = async (xml_id, rtb, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  let url = prefix + `rtb/${xml_id}/re2020`;
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  let body = {
    rtb: rtb,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return { url: "", attestationId: "" };
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return { url: "", attestationId: "" };
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();

    let end = new Date();
    let elapsed = end - start;
    // Add log document (avoid passing full document references)
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      const responseJson = JSON.parse(responseText);
      const url = responseJson.url.trim().replace(/"/g, "");
      const attestationId = responseJson.attestation_id;
      return { url: url, attestationId: attestationId };
    } else {
      // Handle error response
      console.error(`Failed to send rt batiment: ${response.status}`);
      return { url: "", attestationId: ""  };
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return { url: "", attestationId: "" };
  }
};

export default sendRTBatiment;
